export const MASSIVE_CHANGE_TYPES = {
    GENERAL: 'GENERAL',
    VEHICLES_REMOVE: 'VEHICLES_REMOVE',
    VEHICLES_EDIT: 'VEHICLES_EDIT',
};

export const MASSIVE_CHANGE_PARAMS = {
  [MASSIVE_CHANGE_TYPES.VEHICLES_REMOVE]: 'vehicles-massive-remove',
  [MASSIVE_CHANGE_TYPES.VEHICLES_EDIT]: 'vehicles-massive-edit',
};